import { useQuery } from 'react-query';

import { getActivitiesSummary as queryFn } from 'api/endPoints/getActivitiesSummary';

import { IActivitiesSummaryResponse } from 'components/widgets/Gantt/components/ganttChart.types';

export const useQueryActivitiesSummary = (params?: number) => {
    return useQuery<IActivitiesSummaryResponse, QueryError>(['activitiesSummary', params], () => queryFn(params), {
        enabled: typeof params === 'number',
    });
};
